<script setup lang="ts">
import { Prop } from 'vue'
import { FormErrors } from 'vee-validate'
// components
import BasketPricePanelButton from '~/components/Basket/basket-price-panel/BasketPricePanelButton.vue'
// types
import { Cost } from '~/types/api/api-v3/basket'
import { BasketPurchaseButtonEmit } from '~/types/basket'

const emit = defineEmits([...Object.keys(BasketPurchaseButtonEmit)])
defineProps({
  isSectionSticky: {
    type: Boolean,
    required: true,
  },
  amountToPay: {
    type: String,
    required: true,
  },
  basketErrors: {
    type: Object,
    required: true,
  } as Prop<FormErrors<{}>>,
  cost: {
    type: Object,
    required: true,
  } as Prop<Cost>,
  isAuthenticated: {
    type: Boolean,
    required: true,
  },
  isGiftNeed: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
})

const { push } = useRouter()

const orderCheckout = () => emit('orderCheckout')

const goToCatalog = () => push('/')

const goToPayment = () => emit('goToPayment', 'payment_method')

const goToAuthorize = () => emit('goToAuthorize')

const goToAddress = () => emit('goToAddress', 'addresses')

const goToDeliveryAt = () => emit('goToDeliveryAt', 'delivery_at')

const goToDiscount = () => emit('goToDiscount', 'discount')

const goToGifts = () => emit('goToGifts', 'gifts')
</script>

<template>
  <div id="short-panel" class="panel">
    <transition name="height">
      <div v-if="cost?.error_message" class="panel__top">
        {{ cost.message }}
      </div>
    </transition>

    <div class="panel__bottom">
      <div v-if="isSectionSticky" class="panel__bottom-info">
        <div class="value">
          {{ amountToPay }}
        </div>

        <div class="text">Итого</div>
      </div>

      <div class="panel__bottom-button">
        <basket-price-panel-button
          :basket-errors="basketErrors"
          :cost="cost"
          :is-authenticated="isAuthenticated"
          :is-section-sticky="isSectionSticky"
          :is-gift-need="isGiftNeed"
          :is-loading="isLoading"
          @go-to-payment="goToPayment"
          @go-to-catalog="goToCatalog"
          @go-to-purchase="orderCheckout"
          @go-to-authorize="goToAuthorize"
          @go-to-address="goToAddress"
          @go-to-delivery-at="goToDeliveryAt"
          @go-to-discount="goToDiscount"
          @go-to-gifts="goToGifts"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/animations.scss';

.panel {
  display: grid;
  gap: 20px;

  &__top {
    font-size: 12px;
    font-weight: 700;
    color: $dark-grey;
    text-align: center;
  }

  &__bottom {
    display: flex;
    gap: 0 40px;
    justify-content: space-between;

    &-info {
      width: max-content;
      white-space: nowrap;

      .value {
        font-size: 18px;
        font-weight: 800;
      }

      .text {
        font-size: 14px;
        font-weight: 600;
        color: $dark-grey;
      }
    }

    &-button {
      display: flex;
      justify-content: flex-end;
      width: 100%;
    }
  }
}
</style>
